import { isReactNativeApp, sendToNative, subscribeToNative } from '@mobi/web-native-comms/web'

export const startWebviewIsAliveListener = (): void => {
  if (!isReactNativeApp) return

  subscribeToNative('REQUEST_WEBVIEW_IS_ALIVE', () => {
    sendToNative('RESPONSE_WEBVIEW_IS_ALIVE')
  })
}
